'use client';
import React, { startTransition } from 'react';

import { SessionContext } from '@benzinga/session-context';
import { PermissionsManager, PermissionsManagerEvent } from '@benzinga/permission-manager';

/**
 * Hook to check if a user has a permission or not
 */
export const usePermission = (action: string, resource = '#'): boolean => {
  const session = React.useContext(SessionContext);
  const permissionsManager = session.getManager(PermissionsManager);
  const [hasAccess, setHasAccess] = React.useState(() => permissionsManager.hasAccess(action, resource).ok ?? false);

  React.useEffect(() => {
    setHasAccess(permissionsManager.hasAccess(action, resource).ok ?? false);
    const subscription = permissionsManager.subscribe((event: PermissionsManagerEvent) => {
      if (event.type === 'permission_changed') {
        startTransition(() => setHasAccess(permissionsManager.hasAccess(action, resource).ok ?? false));
      }
    });
    return () => subscription.unsubscribe();
  }, [action, permissionsManager, resource]);

  return hasAccess;
};
